import { render, staticRenderFns } from "./DictionaryRange.vue?vue&type=template&id=4b1028e6&scoped=true"
import script from "./DictionaryRange.vue?vue&type=script&lang=js"
export * from "./DictionaryRange.vue?vue&type=script&lang=js"
import style0 from "./DictionaryRange.vue?vue&type=style&index=0&id=4b1028e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1028e6",
  null
  
)

export default component.exports